import { gql } from '@apollo/client';

export const EDUCATION_MATERIAL_FOLDERS = gql`
	query EducationMaterialFolders {
		educationMaterialFolders(pagination: { take: 99 }) {
			data {
				id
				name
				educationMaterials {
					id
					key
					name
					value
					type
					subtype
					link
				}
			}
		}
	}
`;

export const EDUCATION_MATERIAL_FOLDERS_WITH_USER_MATERIALS = gql`
	query EducationMaterialFolders(
		$module: EducationMaterialModule
		$patientId: UUID
		$fulltext: String
	) {
		educationMaterialFolders(module: $module, pagination: { take: 999 }) {
			data {
				id
				name
				educationMaterials(fulltext: $fulltext) {
					id
					key
					name
					value
					type
					subtype
					link
					send(userId: $patientId)
					sendAt(userId: $patientId)
				}
			}
		}
		educationMaterials(
			fulltext: $fulltext
			userId: $patientId
			pagination: { take: 999 }
		) {
			data {
				id
				seen
				seenAt(userId: $patientId)
			}
		}
	}
`;
